import type {
  AttendanceEnumsEmployeeTypeEnum,
  AttendanceEnumsPoolTypeEnum,
} from 'generated/resources/graphql'

export enum AlertType {
  missingClockIn = 'missing_clock_in',
  missingClockOut = 'missing_clock_out',
  missingBreakTime = 'missing_break_time',
  insufficientBreakDuration = 'insufficient_break_duration',
}

export enum PopoverTypeToShow {
  Info = 'info',
  Count = 'count',
}

export const PeriodState = {
  pending: 'pending',
  approved: 'approved',
  in_progress: 'in_progress',
}

export interface NavigationParams {
  year: string
  month: string
  day: string
  periodType: string
  employeeId?: string
}

export const EMPLOYEE_TYPE: Record<'FULL_TIME' | 'PART_TIME', AttendanceEnumsEmployeeTypeEnum> = {
  FULL_TIME: 'full_time',
  PART_TIME: 'part_time',
} as const

export const COMPENSATION_POOL_TYPE: Record<
  'TIMEOFF' | 'VIRTUAL_PAYROLL' | 'BALANCE',
  AttendanceEnumsPoolTypeEnum
> = {
  TIMEOFF: 'timeoff',
  VIRTUAL_PAYROLL: 'virtual_payroll',
  BALANCE: 'balance',
} as const

// Types for Amplitude events properties

export const AmplitudeProps = {
  Origin: {
    ComplementaryHours: 'complementary_hours',
    ExtraHours: 'extra_hours',
  },
  ComplementaryHoursStatus: {
    enabled: 'enabled',
    disabled: 'disabled',
  },
} as const
